// Подпись валюты клуба на сайте брони. Сумма всегда в BYN — настройка меняет
// только ПОДПИСЬ рядом с числом. Локальная копия логики из @billiard/shared
// (сайт брони намеренно не зависит от shared-пакета).
//
//  - 'symbol' — графический знак бел. рубля (SVG), в plain-text → «Br».
//  - 'code'   — ISO-код «BYN» (по умолчанию).
//  - 'short'  — «бел.руб».

export type CurrencyDisplay = 'symbol' | 'code' | 'short'

/**
 * Текстовая подпись валюты — для plain-text контекстов. Знак деградирует до «Br».
 */
export function currencyText(d: CurrencyDisplay): string {
  switch (d) {
    case 'short':
      return 'бел.руб'
    case 'symbol':
      return 'Br'
    case 'code':
    default:
      return 'BYN'
  }
}

/**
 * Inline-SVG знака бел. рубля (Б с горизонтальной чертой). Размер в `em`,
 * заливка — `currentColor`, поэтому знак наследует кегль и цвет текста.
 */
export const CURRENCY_SIGN_SVG =
  '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" width="0.78em" height="0.78em" fill="currentColor" style="display:inline-block;vertical-align:-0.04em" role="img" aria-label="бел. руб.">' +
  '<text x="52" y="50" font-family="Arial, Helvetica, sans-serif" font-size="104" font-weight="700" text-anchor="middle" dominant-baseline="central">Б</text>' +
  '<rect x="6" y="44" width="74" height="11" rx="4"/>' +
  '</svg>'

/**
 * Подпись валюты для React: знак → SVG, остальное → текст.
 */
export function Cur({ display }: { display?: CurrencyDisplay }): React.JSX.Element {
  if (display === 'symbol') {
    return (
      <span
        className="cur-sign"
        aria-label="бел. руб."
        dangerouslySetInnerHTML={{ __html: CURRENCY_SIGN_SVG }}
      />
    )
  }
  return <>{currencyText(display ?? 'code')}</>
}
